import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="autogrow"
export default class extends Controller {
  connect() {
    this.element.style.overflow = "hidden"
    this.element.style.minHeight = "3.2rem"
    this.autogrow()
  }

  input() {
    this.autogrow()
  }

  autogrow() {
    // Reset height to auto to get the correct scrollHeight
    this.element.style.height = "auto"
    // Set the height based on scrollHeight, with a minimum
    const newHeight = Math.max(this.element.scrollHeight, 32)
    this.element.style.height = `${newHeight}px`
  }
}
